// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pictogram_card__-2Q\\+f {
  padding: clamp(1.25rem, 3vw, 2rem);
  gap: 1.5rem;
}

.Pictogram_people__UcZOn {
  display: grid;
  grid-template-columns: repeat(var(--people, 16), minmax(0, 1fr));
  gap: 3px;
  width: 100%;
  max-width: 44rem;
}

.Pictogram_people__UcZOn svg {
  width: 100%;
  height: auto;
}

.Pictogram_filled__18dCj {
  color: var(--primary);
}

.Pictogram_empty__d89Y5 {
  color: #e0e0e0;
}

.Pictogram_label__Igoz3 {
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
}

.Pictogram_results__OGlIL {
  display: grid;
  gap: 0.75rem;
  margin: 1rem 0 0;
  padding-left: 1.25rem;
  font-size: 1.125rem;
  line-height: 1.6;
}

@media (prefers-reduced-motion: no-preference) {
  .Pictogram_card__-2Q\\+f.is-visible .Pictogram_filled__18dCj {
    animation: Pictogram_fillIn__5gKCC 400ms both;
    animation-delay: var(--person-delay);
  }
}

@keyframes Pictogram_fillIn__5gKCC {
  from {
    opacity: 0.2;
    transform: scale(0.85);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 560px) {
  .Pictogram_card__-2Q\\+f {
    padding: 1.125rem;
    gap: 1rem;
  }

  .Pictogram_label__Igoz3 {
    font-size: 1.0625rem;
  }

  .Pictogram_results__OGlIL {
    gap: 0.375rem;
    margin-top: 0.5rem;
    font-size: 0.9375rem;
    line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Research/Pictogram.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,6CAA4B;IAC5B,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;EAClB;AACF","sourcesContent":[".card {\n  padding: clamp(1.25rem, 3vw, 2rem);\n  gap: 1.5rem;\n}\n\n.people {\n  display: grid;\n  grid-template-columns: repeat(var(--people, 16), minmax(0, 1fr));\n  gap: 3px;\n  width: 100%;\n  max-width: 44rem;\n}\n\n.people svg {\n  width: 100%;\n  height: auto;\n}\n\n.filled {\n  color: var(--primary);\n}\n\n.empty {\n  color: #e0e0e0;\n}\n\n.label {\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.results {\n  display: grid;\n  gap: 0.75rem;\n  margin: 1rem 0 0;\n  padding-left: 1.25rem;\n  font-size: 1.125rem;\n  line-height: 1.6;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .card:global(.is-visible) .filled {\n    animation: fillIn 400ms both;\n    animation-delay: var(--person-delay);\n  }\n}\n\n@keyframes fillIn {\n  from {\n    opacity: 0.2;\n    transform: scale(0.85);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 560px) {\n  .card {\n    padding: 1.125rem;\n    gap: 1rem;\n  }\n\n  .label {\n    font-size: 1.0625rem;\n  }\n\n  .results {\n    gap: 0.375rem;\n    margin-top: 0.5rem;\n    font-size: 0.9375rem;\n    line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Pictogram_card__-2Q+f`,
	"people": `Pictogram_people__UcZOn`,
	"filled": `Pictogram_filled__18dCj`,
	"empty": `Pictogram_empty__d89Y5`,
	"label": `Pictogram_label__Igoz3`,
	"results": `Pictogram_results__OGlIL`,
	"fillIn": `Pictogram_fillIn__5gKCC`
};
export default ___CSS_LOADER_EXPORT___;
